import React, { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const PaymentWalletReport = () => {
	const { postCall, getDate, getBill, setViewBillModal, setPayWalletReport, payWalletReport, setGetLoad, getLoad, downloadExcel } = useContext(AppContext);
	const [dateRange, setDateRange] = useState('');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		let wallet = e.target.service.value;
		if (start !== "" && end !== "") {
			setGetLoad(true);
			postCall('api/bnr/get/payment/wallet/report/', { start_date: start, end_date: end, staff_id: staff, wallet_id: wallet }).then(res => {
				setPayWalletReport(res.data);
				setDateRange(`report_payment_wallet_from_${start}_to_${end}`);
				setGetLoad(false);
			}).catch(err => {
				setGetLoad(false);
			});
		}
	}

	const formatExcel = () => {
		if (payWalletReport !== undefined && payWalletReport.wallet_values !== undefined && Object.keys(payWalletReport.wallet_values).length > 0) {
			let data = [];
			Object.keys(payWalletReport.wallet_values).map(b_val => {
				data.push({
					'Date': payWalletReport.wallet_values[b_val].date + ' ' + payWalletReport.wallet_values[b_val].time,
					'Invoice': payWalletReport.wallet_values[b_val].bill_no,
					'Service': payWalletReport.wallet_values[b_val].service,
					'Staff': payWalletReport.wallet_values[b_val].created_by,
					'Customer Name': payWalletReport.wallet_values[b_val].customer_name,
					'Customer Phone': payWalletReport.wallet_values[b_val].customer_phone,
					'Wallet': payWalletReport.wallet_values[b_val].wallet,
					'Amount': parseFloat(payWalletReport.wallet_values[b_val].total).toFixed(2)
				});
			});
			return data;
		}
	}

	return (
		<div className='container-fluid'>
			<div className='grid2by8 align-items-center justify-content-center p-2 bgp br-3 mb-3' >
				<div className='px-2'>
					{
						getLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (
							<span className='text-white' >Payment Wallet Report</span>
						)
					}
				</div>
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									payWalletReport !== undefined ? (
										payWalletReport.users !== undefined ? (
											Object.keys(payWalletReport.users).length > 0 ? (
												Object.keys(payWalletReport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{payWalletReport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="service" className="shadow-none br-2">
								<option value="" >All Wallets</option>
								{
									payWalletReport !== undefined ? (
										payWalletReport.wallets !== undefined ? (
											Object.keys(payWalletReport.wallets).length > 0 ? (
												Object.keys(payWalletReport.wallets).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`serv_${staff_i}`} >{payWalletReport.wallets[staff].name}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={2} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				payWalletReport !== undefined && payWalletReport.wallet_values !== undefined && Object.keys(payWalletReport.wallet_values).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), `${dateRange}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							document.querySelectorAll('.view-bill-link').forEach(el => el.classList.add('hide'));
							generatePDF(tableRef, { filename: `${dateRange}.pdf` });
							document.querySelectorAll('.view-bill-link').forEach(el => el.classList.remove('hide'));
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
							onBeforeGetContent={() => {
								return new Promise((resolve) => {
									document.querySelectorAll('.view-bill-link').forEach(el => el.classList.add('hide'));
									resolve();
								});
							}}
							onAfterPrint={() => {
								document.querySelectorAll('.view-bill-link').forEach(el => el.classList.remove('hide'));
							}}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				{

					payWalletReport !== undefined ? (
						payWalletReport.wallet_values !== undefined ? (
							Object.keys(payWalletReport.wallet_values).length > 0 ? (
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Invoice</span></th>
											<th><span className="tp2" >Service</span></th>
											<th className="tp2" >Staff</th>
											<th className="tp2" ><span>Customer</span></th>
											<th className="text-end tp2" ><span>Amount</span></th>
										</tr>
									</thead>
									<tbody>
										{
											Object.keys(payWalletReport.wallet_values).map((b_val, b_i) => (
												<tr key={`b_val_${b_i}`} >
													<td>
														<div className='d-grid'>
															<div className='d-flex align-items-center' >
																<span onClick={() => {
																	getBill(payWalletReport.wallet_values[b_val].bill_no);
																	setViewBillModal(true);
																}} className="view-bill-link" ><i className="bi bi-receipt"></i> Bill</span>
															</div>
															<span className="tp2" >Invoice : {payWalletReport.wallet_values[b_val].bill_no}</span>
															<span className="tp2 f14" >{payWalletReport.wallet_values[b_val].date}, {payWalletReport.wallet_values[b_val].time}</span>
														</div>
													</td>
													<td className="tp2"><span className="tp2" >{payWalletReport.wallet_values[b_val].service}</span></td>
													<td className="tp2"><span className="tp2" >{payWalletReport.wallet_values[b_val].created_by}</span></td>
													<td>
														<div className='d-grid' >
															<span className="tp2" >{payWalletReport.wallet_values[b_val].customer_name}</span>
															<span className="tp2 f14" >{payWalletReport.wallet_values[b_val].customer_phone}</span>
														</div>
													</td>
													<td className="tp2" >
														<div class="grid8by2 align-items-center" >
															<span className="tp2 " >{payWalletReport.wallet_values[b_val].wallet}</span>
															<div className='d-flex justify-content-end' >
																<span className="tp2 " >{parseFloat(payWalletReport.wallet_values[b_val].total).toFixed(2)}</span>
															</div>
														</div>
													</td>
												</tr>
											))
										}
										{
											payWalletReport.main !== undefined ? (
												<>
													<tr>
														<td colSpan={4} ></td>
														<td className="f18 tp2" >
															{
																payWalletReport.main.wallet_total !== undefined && Object.keys(payWalletReport.main.wallet_total).length > 0 ? (
																	Object.keys(payWalletReport.main.wallet_total).map((wt, wti) => (
																		<div class="grid8by2 align-items-center bdrb2" key={`waaa_${wti}`} >
																			<span className="tp2 " >{wt}</span>
																			<div className='d-flex justify-content-end' >
																				<span className="tp2 " >{parseFloat(payWalletReport.main.wallet_total[wt]).toFixed(2)}</span>
																			</div>
																		</div>
																	))
																) : ''
															}

														</td>
													</tr>
													<tr>
														<td colSpan={4} className='bgy text-end' ><span className="f20" >Total</span></td>
														<td className='bgy text-end' ><span className="f20" >{parseFloat(payWalletReport.main.total).toFixed(2)}</span></td>
													</tr>
												</>
											) : ''
										}

									</tbody>
								</Table>
							) : ''
						) : ''
					) : ''
				}
			</div>

		</div>
	)
}